import { Integration } from '@/types';

/** Integrations that belong to ITSM category (for notifications) */
export const ITSM_NOTIFICATION_INTEGRATIONS = [
  Integration.jira,
  Integration.servicenow,
] as const;

/** Integrations that belong to Chat Messaging category */
export const CHAT_MESSAGING_INTEGRATIONS = [
  Integration.slack,
  Integration.teams,
  Integration.gchat,
  Integration.zulip,
] as const;

/**
 * Shared column width constants for notification tables.
 *
 * Using fixed widths ensures Severity Threshold columns align vertically
 * across different notification sections (Email, Webhooks).
 *
 * These values are used by:
 * - emailColumns.tsx
 * - webhookColumns.tsx
 */
export const NOTIFICATION_TABLE_COLUMN_WIDTHS = {
  /** Primary value column (Email Address / Webhook Name) */
  primaryValue: 370,
  /** Severity threshold column with badge and tooltip */
  severities: 75,
  /** Actions column with ellipsis menu */
  actions: 35,
} as const;
